import { render, staticRenderFns } from "./IndexValue.vue?vue&type=template&id=7b2cc15a&"
import script from "./IndexValue.vue?vue&type=script&lang=js&"
export * from "./IndexValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports